import React from 'react';
import { StyledList } from './StyledList';

interface Props {
  items: string[];
}

export const ProductFeatures = React.memo(({ items }: Props) => {
  return <StyledList mt={2} items={items} />;
});
